<template>
    <span :title="item[col.display]">{{ item[col.display] }}</span>
</template>

<script>
export default {
    name: 'ObjectTableCell',

    props: ['item', 'col'],
}
</script>
